var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('img',{staticClass:"not-found-img",attrs:{"src":"https://i.imgur.com/XK8i1m0.png"}})])}]

export { render, staticRenderFns }